import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Partita iva", -1)
const _hoisted_5 = {
  key: 0,
  class: "form-control"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_input = _resolveComponent("form-input")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_address = _resolveComponent("op-address")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_form_input, {
        class: "col-sm-6",
        type: "text",
        label: "Codice Fiscale",
        modelValue: _ctx.value.codiceFiscale,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.codiceFiscale) = $event)),
        placeholder: "Codice Fiscale",
        readonly: _ctx.readonly
      }, null, 8, ["modelValue", "readonly"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, [
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : (_openBlock(), _createBlock(_component_toggler, {
                  key: 1,
                  modelValue: _ctx.value.hasVat,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.hasVat) = $event))
                }, null, 8, ["modelValue"]))
          ])
        ])
      ])
    ]),
    (_ctx.value.hasVat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_form_input, {
            class: "col-md-4",
            type: "text",
            label: "Numero partita iva",
            modelValue: _ctx.value.vatNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.vatNumber) = $event)),
            placeholder: "Numero partita iva",
            readonly: _ctx.readonly
          }, null, 8, ["modelValue", "readonly"]),
          _createVNode(_component_form_input, {
            class: "col-md-4",
            type: "text",
            label: "Codice destinatario",
            modelValue: _ctx.value.codiceDestinatario,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.codiceDestinatario) = $event)),
            placeholder: "Codice destinatario",
            readonly: _ctx.readonly
          }, null, 8, ["modelValue", "readonly"]),
          _createVNode(_component_form_input, {
            class: "col-md-4",
            type: "text",
            label: "Pec",
            modelValue: _ctx.value.pec,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.pec) = $event)),
            placeholder: "Pec",
            readonly: _ctx.readonly
          }, null, 8, ["modelValue", "readonly"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_form_input, {
        class: "col-md-4",
        type: "date",
        label: "Data di nascita",
        modelValue: _ctx.value.dataNascita,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.dataNascita) = $event)),
        placeholder: "Data di nascita",
        readonly: _ctx.readonly
      }, null, 8, ["modelValue", "readonly"]),
      _createVNode(_component_form_input, {
        class: "col-md-8",
        type: "text",
        label: "Luogo di nascita",
        modelValue: _ctx.value.luogoNascita,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value.luogoNascita) = $event)),
        placeholder: "Luogo di nascita",
        readonly: _ctx.readonly
      }, null, 8, ["modelValue", "readonly"])
    ]),
    _createVNode(_component_op_address, {
      modelValue: _ctx.value.fiscalAddress,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value.fiscalAddress) = $event)),
      readonly: _ctx.readonly,
      label: "Indirizzo residenza"
    }, null, 8, ["modelValue", "readonly"])
  ]))
}